var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8327 5.9782C21.2037 6.3492 21.2037 6.9507 20.8327 7.3217L18.6545 9.49995L20.8327 11.6782C21.2037 12.0492 21.2037 12.6507 20.8327 13.0217C20.4617 13.3927 19.8602 13.3927 19.4892 13.0217L17.311 10.8434L15.1327 13.0217C14.7617 13.3927 14.1602 13.3927 13.7892 13.0217C13.4182 12.6507 13.4182 12.0492 13.7892 11.6782L15.9675 9.49995L13.7892 7.3217C13.4182 6.9507 13.4182 6.3492 13.7892 5.9782C14.1602 5.6072 14.7617 5.6072 15.1327 5.9782L17.311 8.15644L19.4892 5.9782C19.8602 5.6072 20.4617 5.6072 20.8327 5.9782Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8469 0.0869263C11.184 0.241952 11.4 0.57901 11.4 0.950012V18.05C11.4 18.421 11.184 18.758 10.8469 18.9131C10.5099 19.0681 10.1134 19.0127 9.83173 18.7713L3.44857 13.3H0.949999C0.425329 13.3 0 12.8747 0 12.35V6.65C0 6.12533 0.425329 5.7 0.949999 5.7H3.44857L9.83173 0.22872C10.1134 -0.0127258 10.5099 -0.0680997 10.8469 0.0869263ZM9.49999 3.01552L4.41825 7.3713C4.24606 7.51888 4.02677 7.6 3.79999 7.6H1.9V11.4H3.79999C4.02677 11.4 4.24606 11.4811 4.41825 11.6287L9.49999 15.9845V3.01552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.304f0a2dffc6061724b56bbf97505bd2.svg";
export { ForwardRef as ReactComponent };